var map = {
	"./KtbPopularize/bg_title@2x.png": "BdrX",
	"./account/Avatar@2x.png": "D9K5",
	"./account/BG_tuxing.png": "wNkp",
	"./account/Button_n@2x.png": "+fk8",
	"./account/Button_p@2x.png": "mHxP",
	"./account/Certificate_ID_card_a@2x.png": "izc+",
	"./account/Certificate_ID_card_b@2x.png": "Iur7",
	"./account/Certificate_business_license@2x.png": "rgru",
	"./account/Checked@2x.png": "TgOE",
	"./account/HU_NAN_SAN_XIANG.png": "z3nf",
	"./account/Money_bag@2x.png": "9QgJ",
	"./account/PDF.png": "4MOE",
	"./account/Popup@2x.png": "7ipO",
	"./account/Upload@2x.png": "Czil",
	"./account/Upload_p@2x.png": "do8K",
	"./account/Yen_n@2x.png": "0gkn",
	"./account/Yen_red@2x.png": "MRqt",
	"./account/bg.png": "NwKx",
	"./account/bg@2x.png": "ePe1",
	"./account/bg_kongbai_sc.png": "91QJ",
	"./account/bg_shenfenzhengguohui_sc.png": "ru4d",
	"./account/bg_shenfenzhengrenxiang_sc.png": "zsev",
	"./account/bg_yingyezhizhao_sc.png": "fBTT",
	"./account/file.png": "Lf64",
	"./account/fuminAgreement.png": "dgQ4",
	"./account/icon@2x.png": "HjXd",
	"./account/icon_QR_code@2x.png": "9MYk",
	"./account/icon_delete@2x.png": "hs6w",
	"./account/icon_sczp.png": "6NzP",
	"./account/icon_xiangji.png": "zkAv",
	"./account/icon_xiangji_b.png": "+icN",
	"./account/ktbzxkh@2x.png": "nkxj",
	"./account/logo@2x.png": "yyx2",
	"./account/photo_cwbb@2x.png": "XLc3",
	"./account/photo_gszc@2x.png": "hbUL",
	"./account/photo_skzhxx@2x.png": "KyWI",
	"./account/photo_yyzz@2x.png": "uwSx",
	"./account/photo_zxbg@2x.png": "pQCp",
	"./account/pj@2x.png": "nIDd",
	"./account/ruhexuanze.png": "9WdS",
	"./account/word_jpp@2x.png": "TccV",
	"./account/word_pdf@2x.png": "igHB",
	"./account/word_w@2x.png": "5NmN",
	"./account/word_x@2x.png": "QTEg",
	"./account/xlx.png": "6w0O",
	"./activity/2020/202012.less": "h9OH",
	"./activity/2020/app/banner-wenzi.png": "skrH",
	"./activity/2020/app/beijing-bg.png": "WvXy",
	"./activity/2020/app/bg1.png": "C8wd",
	"./activity/2020/app/bg2.png": "mSZ7",
	"./activity/2020/app/huodongshuoming-bg.png": "Ay9z",
	"./activity/2020/app/title-bg.png": "w3zy",
	"./activity/2020/app/xiazaiyouli.png": "v7fZ",
	"./activity/2020/pc/banner-bg.png": "gzJj",
	"./activity/2020/pc/bg-title.png": "pb/e",
	"./activity/2020/pc/bg2.png": "TSNd",
	"./activity/2020/pc/bg3.jpg": "Ml6C",
	"./activity/2020/pc/dadanjiang.png": "DjKu",
	"./activity/2020/pc/erweima.png": "pclD",
	"./activity/2020/pc/fuming.png": "dw9b",
	"./activity/2020/pc/guang.png": "lLlx",
	"./activity/2020/pc/huodongshuoming.png": "L2E8",
	"./activity/2020/pc/lanhai.png": "Hdmh",
	"./activity/2020/pc/leijijiang.png": "cCO5",
	"./activity/2020/pc/leijiyouli.png": "oeu0",
	"./activity/2020/pc/lijitiexian.png": "zvHk",
	"./activity/2020/pc/lijizhuce.png": "agez",
	"./activity/2020/pc/shoudanjiang.png": "fo+U",
	"./activity/2020/pc/shoutieyouli.png": "ZWvE",
	"./activity/2020/pc/title-wenzi.png": "n7Vo",
	"./activity/2020/pc/weizhong.png": "dulp",
	"./activity/2020/pc/zhuangshi.png": "T8aA",
	"./activity/2020/pc/zhuangshi1.png": "bkHV",
	"./activity/2020/pc/zhuceyouli.png": "R2QU",
	"./activity/DiscountAgentInvite/H5/bank-fm.png": "e+wF",
	"./activity/DiscountAgentInvite/H5/bank-ht.png": "97Hi",
	"./activity/DiscountAgentInvite/H5/bank-lh.png": "cTCt",
	"./activity/DiscountAgentInvite/H5/bank-pa.png": "7gV0",
	"./activity/DiscountAgentInvite/H5/bank-ws.png": "+6dO",
	"./activity/DiscountAgentInvite/H5/bank-wz.png": "WnxE",
	"./activity/DiscountAgentInvite/H5/bank-zb.png": "Ednn",
	"./activity/DiscountAgentInvite/H5/bank1.png": "Kd+q",
	"./activity/DiscountAgentInvite/H5/bg1.png": "0FEx",
	"./activity/DiscountAgentInvite/H5/jiantou.png": "M5Oe",
	"./activity/DiscountAgentInvite/H5/kaihu1.png": "0wDE",
	"./activity/DiscountAgentInvite/H5/kuaitiebao.png": "yqED",
	"./activity/DiscountAgentInvite/H5/piaokuan.png": "+9sJ",
	"./activity/DiscountAgentInvite/H5/pingzheng.png": "ekal",
	"./activity/DiscountAgentInvite/H5/weixin-tip.png": "ogti",
	"./activity/DiscountAgentInvite/PC/anquan.png": "T52t",
	"./activity/DiscountAgentInvite/PC/bank.png": "/RDu",
	"./activity/DiscountAgentInvite/PC/bg.png": "c4N0",
	"./activity/DiscountAgentInvite/PC/countdown.gif": "lH8/",
	"./activity/DiscountAgentInvite/PC/fuming.png": "xFpv",
	"./activity/DiscountAgentInvite/PC/hongta.png": "eo2B",
	"./activity/DiscountAgentInvite/PC/kaihu.png": "Qjf2",
	"./activity/DiscountAgentInvite/PC/lanhai.png": "VzmM",
	"./activity/DiscountAgentInvite/PC/piaokuan.png": "TzZl",
	"./activity/DiscountAgentInvite/PC/pingan.png": "stKE",
	"./activity/DiscountAgentInvite/PC/pingzheng.png": "RpEv",
	"./activity/DiscountAgentInvite/PC/wangshang.png": "LmL1",
	"./activity/DiscountAgentInvite/PC/weizhong.png": "GZGv",
	"./activity/DiscountAgentInvite/PC/zhongbang.png": "j1TD",
	"./activity/DiscountAgentInvite/PC/zhucechenggong.png": "7Oc2",
	"./activity/JuneRecharge/bg@2x.png": "7N6P",
	"./activity/JuneRecharge/bg@2x_app.png": "Wqn7",
	"./activity/JuneRecharge/logo@2x.png": "LIeS",
	"./activity/JuneRecharge/title@2x.png": "OC+w",
	"./activity/JuneRecharge/title@2x_app.png": "wTGf",
	"./activity/KtbPlatformInfoMin/bank@2x.png": "QQrf",
	"./activity/KtbPlatformInfoMin/icon_bank@2x.png": "uN/q",
	"./activity/KtbPlatformInfoMin/icon_contract@2x.png": "6SXW",
	"./activity/KtbPlatformInfoMin/icon_invoice@2x.png": "Rh+z",
	"./activity/KtbPlatformInfoMin/icon_pzwy@2x.png": "H6o1",
	"./activity/KtbPlatformInfoMin/icon_zan@2x.png": "r6Hz",
	"./activity/KtbPlatformInfoMin/image_ktiebao@2x.png": "20Mj",
	"./activity/KtbPlatformInfoMin/logo_ktiebao@2x.png": "v6oZ",
	"./activity/KtbPlatformInfoMin/moji_no@2x.png": "FiD9",
	"./activity/KtbPlatformInfoMin/title_a@2x.png": "l4Hn",
	"./activity/KtbPlatformInfoMin/title_b@2x.png": "tTvr",
	"./activity/KtbPlatformInfoMin/watermark_ktiebao@2x.png": "Waan",
	"./activity/KtbTrio/background@2x.png": "0ZQx",
	"./activity/KtbTrio/icon_01@2x.png": "KWJT",
	"./activity/KtbTrio/icon_02@2x.png": "EYq9",
	"./activity/KtbTrio/icon_03@2x.png": "gS6r",
	"./activity/KtbTrio/icon_04@2x.png": "DHRi",
	"./activity/KtbTrio/icon_@2x.png": "HbdV",
	"./activity/KtbTrio/icon_top@2x.png": "TEK4",
	"./activity/KtbTrio/image_01@2x.png": "8zXi",
	"./activity/KtbTrio/image_02@2x.png": "xHVw",
	"./activity/KtbTrio/image_03@2x.png": "tJqK",
	"./activity/KtbTrio/note_b@2x.png": "kDJ5",
	"./activity/KtbTrio_min/Note@2x.png": "Sz4h",
	"./activity/KtbTrio_min/background@2x.png": "MmTh",
	"./activity/KtbTrio_min/icon_01@2x.png": "cvua",
	"./activity/KtbTrio_min/icon_02@2x.png": "krae",
	"./activity/KtbTrio_min/icon_03@2x.png": "m1Q/",
	"./activity/KtbTrio_min/icon_04@2x.png": "UvJF",
	"./activity/KtbTrio_min/icon_top@2x.png": "mmJA",
	"./activity/MYBANK/Advantage_comparison@2x.png": "ZSud",
	"./activity/MYBANK/Banner@2x.png": "WzhG",
	"./activity/MYBANK/go@2x.png": "iQLu",
	"./activity/MYBANK/imac@2x.png": "KKz9",
	"./activity/MYBANK/logo_ktb_h_c@2x.png": "LAG2",
	"./activity/MYBANK/mybank@2x.png": "LiLv",
	"./activity/MYBANK/title@2x.png": "Brhw",
	"./activity/MYBANK_min/bottom@2x.png": "6C/n",
	"./activity/MYBANK_min/title@2x.png": "m4wq",
	"./activity/MYBANK_pc/MYbank@2x.png": "8Un6",
	"./activity/MYBANK_pc/QRcode@2x.png": "vgZ/",
	"./activity/MYBANK_pc/bank@2x.png": "kvgo",
	"./activity/MYBANK_pc/bg_title@2x.png": "FBAJ",
	"./activity/MYBANK_pc/icon_Shielder@2x.png": "YqHm",
	"./activity/MYBANK_pc/icon_arrow@2x.png": "UHmC",
	"./activity/MYBANK_pc/icon_fast@2x.png": "ovsu",
	"./activity/MYBANK_pc/icon_good@2x.png": "oKbY",
	"./activity/MYBANK_pc/icon_off@2x.png": "lQUI",
	"./activity/MYBANK_pc/kuaitiebao@2x.png": "0Zvm",
	"./activity/MYBANK_pc/vs@2x.png": "STgf",
	"./activity/SPSR/app/01.png": "t76T",
	"./activity/SPSR/app/02.png": "sGHl",
	"./activity/SPSR/app/1.png": "PVIF",
	"./activity/SPSR/app/2.png": "t0h9",
	"./activity/SPSR/app/banner-bg.png": "PWuS",
	"./activity/SPSR/app/bottom.png": "P7WN",
	"./activity/SPSR/app/icon-caozuo.png": "Xi4b",
	"./activity/SPSR/app/icon-tuandui.png": "taNa",
	"./activity/SPSR/app/icon_kuaisu.png": "283p",
	"./activity/SPSR/app/icon_wuyou.png": "1G/B",
	"./activity/SPSR/app/liucheng.png": "Tqa9",
	"./activity/SPSR/app/youshi.png": "8iz3",
	"./activity/SPSR/bg1@2x.png": "/XeB",
	"./activity/SPSR/bg1_01.png": "mX3n",
	"./activity/SPSR/bg2@2x.png": "52Sh",
	"./activity/SPSR/bg4@2x.png": "w5iq",
	"./activity/SPSR/bg_step1@2x.png": "yjKC",
	"./activity/SPSR/btn1@2x.png": "jFfz",
	"./activity/SPSR/icon1@2x.png": "7zFj",
	"./activity/SPSR/icon2@2x.png": "PJHG",
	"./activity/SPSR/icon3@2x.png": "7ln3",
	"./activity/SPSR/icon4@2x.png": "UeHF",
	"./activity/SPSR/icon_01@2x.png": "/NGB",
	"./activity/SPSR/icon_0@2x.png": "xLrf",
	"./activity/SPSR/icon_1@2x.png": "gnTt",
	"./activity/SPSR/icon_5@2x.png": "svFz",
	"./activity/SPSR/icon_6@2x.png": "JWpb",
	"./activity/SPSR/image_shangpiao@2x.png": "V32J",
	"./activity/SPSR/images_pianbi@2x.png": "J3tY",
	"./activity/SPSR/logo1@2x.png": "D01n",
	"./activity/SPSR/logo2@2x.png": "nkfy",
	"./activity/SPSR/logo3@2x.png": "YCBB",
	"./activity/SPSR/logo4@2x.png": "2MsF",
	"./activity/SPSR/logo5@2x.png": "myxi",
	"./activity/SPSR/logo6@2x.png": "je5Z",
	"./activity/SPSR/title1@2x.png": "Is04",
	"./activity/SPSR/title2@2x.png": "cUeu",
	"./activity/WZBankMin/bg1.png": "7yht",
	"./activity/WZBankMin/bg2.png": "gY5o",
	"./activity/WZBankMin/biaoti-bg.png": "PEoe",
	"./activity/WZBankMin/btn.png": "CDr8",
	"./activity/WZBankMin/hongbao-red-dadan.png": "udwB",
	"./activity/WZBankMin/hongbao-red-leiji.png": "2qfH",
	"./activity/WZBankMin/hongbao-red-shoudan.png": "72Q0",
	"./activity/WZBankMin/hongbao-yellow.png": "sPHz",
	"./activity/WZBankMin/kuaitiebao-logo.png": "r7ME",
	"./activity/WZBankMin/sanjiao1.png": "r4w8",
	"./activity/WZBankMin/sanjiao2.png": "yEeN",
	"./activity/WZBankMin/weizhong-logo.png": "TAT9",
	"./activity/WZBankMin/wenzi.png": "zNes",
	"./activity/WZBankMin/wep.png": "D0Lt",
	"./activity/WZBankPC/bg1.png": "4sKV",
	"./activity/WZBankPC/bg2.png": "S4Og",
	"./activity/WZBankPC/biaoti-bg.png": "ne7q",
	"./activity/WZBankPC/btn.png": "ZKLt",
	"./activity/WZBankPC/hongbao-red-dadan.png": "cC58",
	"./activity/WZBankPC/hongbao-red-leiji.png": "PK3/",
	"./activity/WZBankPC/hongbao-red-shoudan.png": "xy4w",
	"./activity/WZBankPC/hongbao-yellow.png": "Dzro",
	"./activity/WZBankPC/kuaitiebao-logo.png": "Q+z2",
	"./activity/WZBankPC/sanjiao1.png": "R/TX",
	"./activity/WZBankPC/sanjiao2.png": "L1eS",
	"./activity/WZBankPC/weizhong-logo.png": "rAye",
	"./activity/WZBankPC/wenzi.png": "DCGp",
	"./activity/ZBActivity/bg@2x.png": "WDvC",
	"./activity/ZBActivity/bg_02@2x.png": "xNuA",
	"./activity/ZBActivity/bg_02_li@2x.png": "zjZm",
	"./activity/ZBActivity/bg_03@2x.png": "f8OG",
	"./activity/ZBActivity/bg_title@2x.png": "aFzB",
	"./activity/ZBActivity/icon_medal@2x.png": "tXLh",
	"./activity/ZBActivity/icon_medal_2@2x.png": "Z58N",
	"./activity/ZBActivity/icon_redbag@2x.png": "1/mk",
	"./activity/ZBActivity/logo_zbank_vertical_color@2x.png": "hIYZ",
	"./activity/ZBActivity/redbag@2x.png": "P0CH",
	"./activity/ktb/bg_bottom@2x.png": "Zgyj",
	"./activity/ktb/bg_fwys@2x.png": "Emvu",
	"./activity/ktb/bg_title@2x.png": "O5tD",
	"./activity/ktb/checkbox@2x.png": "Da7c",
	"./activity/ktb/icon@2x.png": "PLm9",
	"./activity/ktb/image_title@2x.png": "gnTB",
	"./activity/ktb/table@2x.png": "ANLi",
	"./activity/ktb/title@2x.png": "KW5t",
	"./activity/ktbConsociation/BG@2x.png": "WA1c",
	"./activity/ktbConsociation/Combined@2x.png": "Zd7x",
	"./activity/ktbConsociation/Compared@2x.png": "GHcz",
	"./activity/ktbConsociation/bank@2x.png": "i9ay",
	"./activity/ktbConsociation/icon@2x.png": "zzAx",
	"./activity/ktbConsociation/success@2x.png": "z3ZR",
	"./activity/ktbConsociation/title@2x.png": "0cPs",
	"./activity/ktbPopularize/bg_title@2x.png": "Rzo0",
	"./activity/ktbPopularize/btn_reg@2x.png": "gxv9",
	"./activity/ktbPopularize/image_title@2x.png": "OI7D",
	"./activity/ktbPopularize/title@2x.png": "xADb",
	"./activity/ktb_min/bg_fwys@2x.png": "tDJS",
	"./activity/ktb_min/bottom@2x.png": "ZSRz",
	"./activity/ktb_min/hzms@2x.png": "BGuU",
	"./activity/ktb_min/icon@2x.png": "eu3G",
	"./activity/ktb_min/image@2x.png": "S+qc",
	"./activity/ktb_min/title@2x.png": "yBoh",
	"./applicationDiscount/Acceptance_bill_picture@2x.png": "SGE0",
	"./applicationDiscount/B_zhuce.png": "ZHrJ",
	"./applicationDiscount/Background_image_a@2x.png": "YdTh",
	"./applicationDiscount/BusinessBg@2x.png": "9xbR",
	"./applicationDiscount/Checked_gray@2x.png": "qL2x",
	"./applicationDiscount/Checked_red@2x.png": "g6xo",
	"./applicationDiscount/Loading@2x.png": "at9y",
	"./applicationDiscount/Pencil_black_gross_tool@2x.png": "J+ec",
	"./applicationDiscount/Pickup@2x.png": "goh4",
	"./applicationDiscount/bg@2x.png": "xB8A",
	"./applicationDiscount/bg_Bill_texture@2x.png": "BonJ",
	"./applicationDiscount/bill@2x.png": "5mMo",
	"./applicationDiscount/c_caozuoxinxi.png": "u9XJ",
	"./applicationDiscount/d_xieyi.png": "/Gp2",
	"./applicationDiscount/e-gudong.png": "5q5o",
	"./applicationDiscount/icon_bank@2x.png": "6w5S",
	"./applicationDiscount/icon_bczi@2x.png": "pB9Z",
	"./applicationDiscount/icon_picture@2x.png": "PUtX",
	"./applicationDiscount/icon_shenhetijiao.png": "zBb2",
	"./applicationDiscount/icon_small_ddwc.png": "gipM",
	"./applicationDiscount/icon_ysb@2x.png": "oP7w",
	"./applicationDiscount/icon_ysb_a@2x.png": "Hx75",
	"./applicationDiscount/image_fill.png": "VeA/",
	"./applicationDiscount/image_fill_small.png": "D2hA",
	"./applicationDiscount/iphonex@2x.png": "VvVM",
	"./applicationDiscount/logo@2x.png": "qXjJ",
	"./applicationDiscount/logo_ktie_point@2x.png": "R1lp",
	"./applicationDiscount/navigation@2x.png": "gKbr",
	"./applicationDiscount/shilitu@2x.png": "aiiA",
	"./applicationDiscount/sjx.png": "8yX0",
	"./applicationDiscount/sys@2x.png": "gBXk",
	"./applicationDiscount/tU_b@2x.png": "24Cq",
	"./applicationDiscount/wechat_QR_code_a.png": "mudX",
	"./applicationDiscount/wechat_fill.png": "8n6K",
	"./bankInfoBg/FUMIN.png": "wqMN",
	"./bankInfoBg/HUARUN.png": "BQmd",
	"./bankInfoBg/PINGAN.png": "ekVP",
	"./bankInfoBg/SANXIANG.png": "dHvS",
	"./bankInfoBg/WHLH.png": "Db4K",
	"./bankInfoBg/WZ.png": "ceT7",
	"./bankInfoBg/YNHT.png": "qMwh",
	"./businessTicketDiscount/Excel.png": "99YP",
	"./businessTicketDiscount/ICON_SHZ.png": "ymYG",
	"./businessTicketDiscount/ICON_SHZ@2x.png": "AkNy",
	"./businessTicketDiscount/ICON_ddslsb.png": "J0l0",
	"./businessTicketDiscount/PDF.png": "n3YT",
	"./businessTicketDiscount/Plus@2x.png": "Pvv0",
	"./businessTicketDiscount/bg_Bill_texture.png": "mVbe",
	"./businessTicketDiscount/dzsp.png": "Sy79",
	"./businessTicketDiscount/icon_bsz.png": "nBg1",
	"./businessTicketDiscount/icon_cg.png": "WX8B",
	"./businessTicketDiscount/icon_fz.png": "aZQ/",
	"./businessTicketDiscount/icon_gb.png": "GM2D",
	"./businessTicketDiscount/icon_hkcg.png": "O7eY",
	"./businessTicketDiscount/icon_quxiao.png": "/yuf",
	"./businessTicketDiscount/icon_shanchu.png": "rUmQ",
	"./businessTicketDiscount/icon_time.png": "HXpK",
	"./businessTicketDiscount/icon_wenti.png": "wSmV",
	"./businessTicketDiscount/icon_wenti@2x.png": "VScU",
	"./businessTicketDiscount/icon_xiadanchenggong.png": "+0vu",
	"./businessTicketDiscount/kapian_a.png": "XIyv",
	"./businessTicketDiscount/kapian_b.png": "dsTP",
	"./businessTicketDiscount/sy@2x.png": "1UTQ",
	"./businessTicketDiscount/tU_b@2x.png": "i9mN",
	"./businessTicketDiscount/tongyong.png": "Wa0a",
	"./businessTicketDiscount/wen@2x.png": "scky",
	"./businessTicketDiscount/wenjian_sc_a.png": "d+B8",
	"./businessTicketDiscount/wenjian_sc_a@2x.png": "NG1R",
	"./businessTicketDiscount/wenjian_sc_b.png": "M3RN",
	"./businessTicketDiscount/wenjian_sc_b@2x.png": "NZ7j",
	"./businessTicketDiscount/wenjian_zhuijia.png": "1u/1",
	"./businessTicketDiscount/wenjian_zhuijia@2x.png": "aVT+",
	"./businessTicketDiscount/word.png": "7G6H",
	"./commission/link.png": "G/NA",
	"./commission/qr_code_fill.png": "9X2b",
	"./commission/ririying_banner.png": "3SDs",
	"./commission/sxstl_banner.png": "JJR5",
	"./commission/tiao.png": "0JEL",
	"./commission/tiao@2x.png": "hOvD",
	"./common/icon_hanghaochaxun.png": "U12p",
	"./common/icon_jsq.png": "9vWP",
	"./discountTrends/Bank@2x.png": "Uo79",
	"./discountTrends/File@2x.png": "5m4u",
	"./discountTrends/Invoice@2x.png": "xCIs",
	"./discountTrends/LOGO.png": "hzaq",
	"./discountTrends/Pad@2x.png": "n1WQ",
	"./download/bg1.png": "WFIz",
	"./download/bg2.png": "zzo6",
	"./download/erweima-tongyong.png": "lfKY",
	"./download/icon-android.png": "Ai/P",
	"./download/icon-android1.png": "9HDk",
	"./download/icon-baojia.png": "FjA2",
	"./download/icon-ios.png": "gCdD",
	"./download/icon-ios1.png": "3g/c",
	"./download/icon-pinzheng.png": "4J42",
	"./download/icon-qianyue.png": "O9Pt",
	"./download/icon-xunjia.png": "FdnZ",
	"./download/iphone-baojia.png": "HooU",
	"./download/iphone-pinzheng.png": "Mu3i",
	"./download/iphone-qianyue.png": "svvv",
	"./download/iphone-shouye.png": "L9NA",
	"./download/iphone-xunjia.png": "vIyN",
	"./download/iphone.png": "g0ub",
	"./download/slogan.png": "2L7a",
	"./download/title-line.png": "l+JO",
	"./download/title-line1.png": "xA+z",
	"./download/yinying.png": "ftiO",
	"./download/yinying1.png": "FKMz",
	"./home/1.jpg": "clxy",
	"./home/2.jpg": "cXqj",
	"./home/3.jpg": "hU4X",
	"./home/BG_d@2x.png": "LcAF",
	"./home/Bank@2x.png": "zFNA",
	"./home/Close@2x.png": "YrGn",
	"./home/TV.png": "zspv",
	"./home/bg@2x.png": "MVla",
	"./home/go@2x.png": "/yxA",
	"./home/gongan.png": "chor",
	"./home/icon_xinshouzhiyin.png": "dqcl",
	"./home/ktb_phto@2x.png": "nuFA",
	"./home/logo@2x.png": "d3xt",
	"./home/logo@2x_back.png": "EuwF",
	"./home/new.png": "ccUw",
	"./home/new@2x.png": "FAJu",
	"./home/tab/Discount_now_n_a.png": "e2Ay",
	"./home/tab/Discount_now_n_b.png": "GFB9",
	"./home/tab/F_b.png": "Q/Wo",
	"./home/tab/bg_Graphics.png": "LEcO",
	"./home/tab/bg_photo.png": "lkMe",
	"./home/tab/bg_photo_back.png": "+CVO",
	"./home/tab/box.png": "Csl4",
	"./home/tab/box_path.png": "ERgo",
	"./home/tab/dzcdhp.png": "GrvJ",
	"./home/tab/dzcdhpb.png": "p72X",
	"./home/tab/f_b1.png": "gHIR",
	"./home/tab/icon_yuan.png": "Eijm",
	"./home/tab/shangye.png": "mUN0",
	"./home/tab/yinhang.png": "IkUy",
	"./img_red_packet/Red_envelope@2x.png": "epbI",
	"./img_red_packet/Red_envelope_body@2x.png": "zTto",
	"./img_red_packet/Red_envelope_body_Sleek@2x.png": "gtX1",
	"./img_red_packet/Red_envelope_head@2x.png": "0nmN",
	"./img_red_packet/Red_envelope_head_Sleek@2x.png": "Ju37",
	"./img_red_packet/Red_envelope_y@2x.png": "AvfJ",
	"./img_red_packet/Small_red_envelope@2x.png": "qv63",
	"./img_red_packet/paper@2x.png": "YG9Z",
	"./information/bj@2x.png": "HTWe",
	"./platformIntroduce/01.png": "zxwG",
	"./platformIntroduce/02.png": "cue5",
	"./platformIntroduce/03.png": "kXs+",
	"./platformIntroduce/04.png": "XOBd",
	"./platformIntroduce/bg1.png": "eQ6v",
	"./platformIntroduce/bg2.png": "kZ7E",
	"./platformIntroduce/bianjie.png": "lIsD",
	"./platformIntroduce/icon-bank.png": "bLIw",
	"./platformIntroduce/icon-caozuo@2x.png": "9Hvo",
	"./platformIntroduce/icon-fangkuan.png": "lbxR",
	"./platformIntroduce/icon-huoqu@2x.png": "N+sT",
	"./platformIntroduce/icon-kaihu.png": "IaMi",
	"./platformIntroduce/icon-miaoji.png": "4IY9",
	"./platformIntroduce/icon-pinzheng.png": "tc5v",
	"./platformIntroduce/icon-pinzheng@2x.png": "BRqM",
	"./platformIntroduce/icon-shenhe.png": "I1EH",
	"./platformIntroduce/icon-shijian.png": "ero8",
	"./platformIntroduce/icon-supei.png": "KhPS",
	"./platformIntroduce/icon-tijiao@2x.png": "HJB/",
	"./platformIntroduce/icon-xuanze.png": "jtxm",
	"./platformIntroduce/icon-xunjia.png": "n8KQ",
	"./platformIntroduce/icon-xunzhao.png": "W6TC",
	"./platformIntroduce/icon-yewu.png": "SAYQ",
	"./platformIntroduce/icon-ziliao.png": "yray",
	"./platformIntroduce/img@2x.png": "PYdZ",
	"./platformIntroduce/juxing-hui.png": "1F5b",
	"./platformIntroduce/juxing-red.png": "DoLC",
	"./platformIntroduce/kuaisu.png": "KnMU",
	"./platformIntroduce/mac.png": "fPQ8",
	"./platformIntroduce/mac1.png": "PMMV",
	"./platformIntroduce/quxian.png": "+qiq",
	"./platformIntroduce/rongzi-btn.png": "1K1b",
	"./platformIntroduce/sanjiao-down.png": "Fo2T",
	"./platformIntroduce/sanjiao.png": "avgF",
	"./platformIntroduce/shangpiaosurong@2x.png": "gNRJ",
	"./platformIntroduce/shouxin.png": "DS4J",
	"./platformIntroduce/tiexian-btn.png": "zC5w",
	"./platformIntroduce/tuandui.png": "5XMI",
	"./platformIntroduce/yinpiaokuaitie.png": "eGGL",
	"./platformIntroduce/yuan3.png": "dkkQ",
	"./platformIntroduce/yuanquan.png": "bjqN",
	"./platformIntroduce/zhuangshi.png": "8+cw",
	"./platformIntroduce/zhuangshi1.png": "idoa",
	"./seo/banyuan.png": "xNtL",
	"./seo/bg.png": "fZ9+",
	"./seo/bg1.png": "rYQY",
	"./seo/bg2.png": "8Cg7",
	"./seo/bg3.png": "lMQ2",
	"./seo/bg4.png": "YVvH",
	"./seo/bill@2x.png": "ftoJ",
	"./seo/chadiao.png": "lq0m",
	"./seo/chuantong.png": "47Kp",
	"./seo/clock.png": "Wv8N",
	"./seo/gou.png": "AAFq",
	"./seo/gou1.png": "PaZc",
	"./seo/jiantou.png": "r4e8",
	"./seo/liucheng.png": "kgIt",
	"./seo/logo.png": "UR5E",
	"./seo/piaoju.png": "Rf56",
	"./seo/touxiang.png": "lYHi",
	"./seo/you.png": "M6EN",
	"./seo/you1.png": "Ccwt",
	"./seo/zuo.png": "RUs8",
	"./seo/zuo1.png": "ZJwk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 69